import { authHeader, shopAuthHeader, ApiConfigs } from '../_helpers';

export const userService = {
    getAll,
    updateProfile,
    getAddresses,
    addAddress,
    updateAddress,
    deleteAddress,
    updateSizes,
    getDna,
    createDna,
    getSizes,
    getUnsetSizes,
    updateWallet,
    getPurchases,
    getById,
    updateUserSub
};

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: {...authHeader(), 'Content-Type': 'application/json'},
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.getAll}`, requestOptions).then(handleResponse);
}

function updateWallet(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...authHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.updateWallet}`, requestOptions).then(handleResponse);
}

function updateProfile(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.update_profile_infomation.replace(':id', data.id)}`, requestOptions).then(handleResponse);
}

function getAddresses() {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.getAllAddresses}`, requestOptions).then(handleResponse);
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.getById.replace(":id", id)}`, requestOptions).then(handleResponse);
}

function updateAddress(id, data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.updateAddress.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function addAddress(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.addNewAddress}`, requestOptions).then(handleResponse);
}

function deleteAddress(id) {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'}
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.deleteAddress.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function updateSizes(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.updateSizes}`, requestOptions).then(handleResponse);
}

function getDna() {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.getDna}`, requestOptions).then(handleResponse);
}

function createDna(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.createDna}`, requestOptions).then(handleResponse);
}

function updateUserSub(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader() },
        body: data
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.updateUserSub}`, requestOptions).then(handleResponse);
}

function getSizes() {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.getSizes}`, requestOptions).then(handleResponse);
}

function getUnsetSizes() {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.getUnsetSizes}`, requestOptions).then(handleResponse);
}

function getPurchases() {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.user.getPurchases}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) { localStorage.removeItem('user');
                // auto logout if 401 response returned from api
                /*location.reload(true);*/
                window.location.href = '/shop/login';
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}